"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeBuildProjectDefinition = serializeBuildProjectDefinition;
exports.serializeObjectBlobsToString = serializeObjectBlobsToString;
async function serializeBuildProjectDefinition(project, serializeObjectBlobs = serializeObjectBlobsToString) {
    return serializeObjectBlobs(project);
}
async function serializeObjectBlobsToString(obj, blobToBase64 = blobToBase64Browser) {
    const result = {};
    for (const key in obj) {
        const value = obj[key];
        if (value instanceof Blob) {
            result[key] = `base64blob:${await blobToBase64(value)}`;
        }
        else if (!value) {
            result[key] = value;
        }
        else if (typeof value === 'object') {
            result[key] = await serializeObjectBlobsToString(value, blobToBase64);
        }
        else {
            result[key] = value;
        }
    }
    return result;
}
function blobToBase64Browser(value) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(value);
    });
}
//# sourceMappingURL=build.js.map